// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { H3 } from 'quark-web'
// local imports
import { Text, Header, Carousel } from '~/components'
import styles from './styles'
import {FlexColumn} from 'quark-web'
import './../basicResponsive.css'

const Research = () => (
    <div style = {styles.container}>
        <Helmet title="Research" />

        <FlexColumn
         justifyContent="center"
         style={styles.column}>
            <Header style={styles.header}>Research</Header>
            <div className={'content'}>
                <Text>
                    Lark Seeds International is devoted to innovation and disruptive technologies.{"\n\n"}

                    Our research is focused on finding and developing new hybrids along with sustainable 
                    agricultural solutions to help farmers increase yields and address macro environmental 
                    challenges such as natural resource scarcity and climate change. {"\n\n"}

                    Our breeding team is using data analytics expertly to connect the ultimate 
                    end-consumer needs with the features, benefits, disease package and commercial 
                    attributes a hybrid must have to solve various constraints across a multitude 
                    of stakeholders in the value chain. {"\n\n"}
                    
                    Securing incremental quality and efficiency harvest-after-harvest along with cost 
                    optimization are fundamental elements of our strategy when developing and trialing 
                    varieties which are carefully selected and added into our portfolio. We maintain a 
                    constant flow of fresh new product introductions to ensure a competitive offering
                    considering the fast-changing agronomic and planting conditions. {"\n\n"}

                    Our core mission is to mitigate the risk of our growers and unleash value through 
                    innovative tools that have a sound impact all the way to the consumer level.
                </Text>
            </div>
        </FlexColumn>
    </div>
)

export default Research



// WEBPACK FOOTER //
// ./src/views/Research/index.js